import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import A11y from 'chameleon/ui-stack/utilities/a11y';

class Tab extends PureComponent {
  static propTypes = {
    /* the current active Tab index */
    activeTab: PropTypes.number.isRequired,
    /* tab click handler */
    onClick: PropTypes.func.isRequired,
    /* Tab index */
    index: PropTypes.number.isRequired,
    /* optional tab label */
    label: PropTypes.string,
    /* custom active className when the tab is clicked */
    activeClassname: PropTypes.string,
  };

  onClick = () => {
    const { onClick, index } = this.props;
    onClick(index);
  };

  /**
   * Keydown handler to allow use of
   * - spacebar and return to select active help tab
   */
  keyDownHandler = (event) => {
    // only handle pressing of left and right arrow keys, spacebar and return
    if ([13, 32].includes(event.keyCode)) {
      // Make sure to stop event bubbling
      event.preventDefault();
      event.stopPropagation();

      const { onClick, index } = this.props;
      onClick(index);
    }
  };

  render() {
    const { activeTab, label, icon, index, className, activeClassname } =
      this.props;

    let tabActiveClassname = '';
    if (activeTab === index) {
      tabActiveClassname = activeClassname || 'Tab--active';
    }
    let tabStyles = classNames('Tab', className, tabActiveClassname);
    return (
      <A11y>
        <div
          className={tabStyles}
          aria-label={label}
          onClick={this.onClick}
          role="tab"
          tabIndex="0"
          aria-selected={activeTab === index}
          onKeyDown={this.keyDownHandler}
        >
          {label || icon}
        </div>
      </A11y>
    );
  }
}

export default Tab;
